// Product Gallery Dot Pagination
// Syncs independent dot navigation with the media gallery slider

if (!customElements.get('media-gallery')) {
  console.warn('media-gallery custom element not found');
}

document.addEventListener('DOMContentLoaded', function() {
  const mediaGalleries = document.querySelectorAll('media-gallery');
  mediaGalleries.forEach((gallery) => {
    const dotsContainer = gallery.querySelector('.product-gallery-dots');
    if (!dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.product-gallery-dot');
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || !dots.length) return;
    
    // Handle dot clicks - navigate to corresponding slide
    dots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        const mediaId = this.getAttribute('data-media-id');
        if (!mediaId) return;

        const targetSlide = viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!targetSlide) return;

        viewer.querySelectorAll('[data-media-id]').forEach(slide => slide.classList.remove('is-active'));
        dots.forEach(d => d.classList.remove('is-active'));

        targetSlide.classList.add('is-active');
        this.classList.add('is-active');

        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

        const counterCurrent = gallery.querySelector('.slider-counter--current');
        if (counterCurrent) counterCurrent.textContent = index + 1;
      });
    });
    
    // Listen for slide changes (from arrows, swipe, etc.) and update dots
    viewer.addEventListener('slideChanged', function(event) {
      if (!event.detail || !event.detail.currentElement) return;
      const currentMediaId = event.detail.currentElement.getAttribute('data-media-id');
      dots.forEach((dot) => {
        const dotMediaId = dot.getAttribute('data-media-id');
        const dotIdEnd = dotMediaId.split('-').pop();
        const slideIdEnd = currentMediaId.split('-').pop();
        if (dotIdEnd === slideIdEnd || dotMediaId === currentMediaId) dot.classList.add('is-active');
        else dot.classList.remove('is-active');
      });
    });
    
    // Also listen for scroll events to update dots when user swipes
    const slider = viewer.querySelector('[id^="Slider-Gallery"]');
    
    if (slider) {
      slider.addEventListener('scroll', function() {
        const slides = slider.querySelectorAll('.slider__slide[data-media-id]');
        const scrollLeft = slider.scrollLeft;
        const sliderWidth = slider.offsetWidth;
        
        let closestSlide = null;
        let minDistance = Infinity;
        
        slides.forEach(slide => {
          const slideLeft = slide.offsetLeft;
          const slideCenter = slideLeft + (slide.offsetWidth / 2);
          const viewportCenter = scrollLeft + (sliderWidth / 2);
          const distance = Math.abs(slideCenter - viewportCenter);
          
          if (distance < minDistance) {
            minDistance = distance;
            closestSlide = slide;
          }
        });
        
        if (closestSlide) {
          const mediaId = closestSlide.getAttribute('data-media-id');
          dots.forEach((dot) => {
            const dotMediaId = dot.getAttribute('data-media-id');
            const dotIdEnd = dotMediaId.split('-').pop();
            const slideIdEnd = mediaId.split('-').pop();
            if (dotIdEnd === slideIdEnd || dotMediaId === mediaId) dot.classList.add('is-active');
            else dot.classList.remove('is-active');
          });
        }
      });
    }
  });
});
